var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"calc(100vh - 90px)"}},[_c('tabs',{staticClass:"border-bottom",attrs:{"tabs":_vm.tabs}}),_c('div',{staticClass:"pt-2",staticStyle:{"height":"calc(100vh - 140px)"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }